module.exports = __webpack_public_path__ + "static/media/signboard.e28cc129.png";